import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { StatusPageViewer } from './status-pages';
import './styles.css';

// Public readers need the viewer, not the workspace management application.
const App = lazy(() => import('./main'));
const pathname = window.location.pathname;
createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/^\/status\/private\/sp_[a-f0-9-]+$/.test(pathname) ? (
      <StatusPageViewer privateId={pathname.split('/')[3]} />
    ) : /^\/status\/[a-z0-9][a-z0-9-]{1,46}[a-z0-9]$/.test(pathname) ? (
      <StatusPageViewer slug={pathname.split('/')[2]} />
    ) : (
      <Suspense fallback={<main role="status">Loading OpsAI…</main>}>
        <App />
      </Suspense>
    )}
  </React.StrictMode>,
);
